import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-custom-date-range-picker',
  templateUrl: './custom-date-range-picker.component.html',
  styleUrls: ['./custom-date-range-picker.component.scss']
})
export class CustomDateRangePickerComponent {
  @Output() rangeSelected = new EventEmitter<[Date, Date]>();
  @Output() close = new EventEmitter<void>();

  startDate: string = '';
  endDate: string = '';

  submitRange() {
    if (this.startDate && this.endDate) {
      this.rangeSelected.emit([new Date(this.startDate), new Date(this.endDate)]);
    }
  }
}
